// extracted by mini-css-extract-plugin
module.exports = {"select":"_2x0OhurcooE0PKGPjvbjJ0"};